<template>
    <v-layout row>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-btn slot="activator" color="secondary" class="text--primary">Create status order</v-btn>
            <v-card>

                <form v-on:submit.prevent="create">
                    <v-card-title>
                        <span class="headline">Create status order</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.name"
                                            :error-messages="errors.collect('data.name')"
                                            label="Name"
                                            data-vv-name="data.name"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 s6 md6>
                                    <v-text-field
                                            v-validate="'required'"
                                            v-model="data.description"
                                            :error-messages="errors.collect('data.description')"
                                            label="Description"
                                            data-vv-name="data.description"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                        <v-btn color="blue darken-1" flat type="submit">Create</v-btn>
                    </v-card-actions>
                </form>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        data: () => ({
            dialog: false,
            data : {
                description : '',
                name: ''
            },
        }),
        methods: {
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$store.dispatch('createStatusOrders', this.data).then((res) => {
                            this.$emit('created');
                            this.data = {
                                description : '',
                                name: ''
                            };
                            this.dialog = false
                        }).catch((error) => {

                        });
                    }
                });
            },
            cancel () {
                this.dialog = false;
                this.data = {
                    description : '',
                    name: ''
                };
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/admin/config/statuses/orders/components/CreateModal.vue